// extracted by mini-css-extract-plugin
export var resultsMessage = "project-grid-module--resultsMessage--12jXc";
export var grid = "project-grid-module--grid--MuqSM";
export var projectCard = "project-grid-module--projectCard--36AO4";
export var projectCardImageContainer = "project-grid-module--projectCardImageContainer--1PN4x";
export var projectCardImage = "project-grid-module--projectCardImage--1Sygl";
export var projectCardLink = "project-grid-module--projectCardLink--3ChRC";
export var projectCardTitle = "project-grid-module--projectCardTitle--3ihbf";